import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "px-x3" }
const _hoisted_2 = { class: "text-center -mt-5 pr-30 mb-x4 xl:text-28" }
const _hoisted_3 = { class: "pt-20 pb-50 text-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href", "title"]
const _hoisted_6 = {
  key: 1,
  class: "mt-x4"
}

import { computed } from 'vue';
import { LinkModel } from '@/types/B2CcontentServerContract';
import siteContextStore, { GlobalLabels } from '@/shared/content/site-context.store';
import siteContextService from '@/b2c/shared/site-context.service';
import { QueryKeys } from '@/shared/config/route-query.config';
import { router } from '@/core/router';
import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';
import useGlobalLabels from '@/shared/content/useGlobalLabels';


export default /*#__PURE__*/_defineComponent({
  __name: 'WishlistLogin',
  setup(__props) {

const labels = useGlobalLabels(GlobalLabels.wishlist);
const loginLink = computed<LinkModel>(() => {
    return siteContextStore.settings.loginLink;
});

const loginParams = computed(() => {
    return {
        [QueryKeys.ReturnUrl]: router.currentRoute.value.path,
        [QueryKeys.Title]: 'Wishlists',
        [QueryKeys.ReturnTypeHard]: true,
    };
});

const createProfileLink = computed<LinkModel | undefined>(() => {
    return siteContextService.createProfileLink;
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(labels).loginTitle), 1),
    _createElementVNode("div", _hoisted_3, [
      (_unref(loginLink))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_unref(loginLink).spaLink)
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 0,
                  class: "c-button",
                  to: { path: _unref(loginLink).url, query: _unref(loginParams) },
                  title: _unref(labels).loginLink
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(labels).loginLink), 1)
                  ]),
                  _: 1
                }, 8, ["to", "title"]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: _unref(loginLink).url,
                  title: _unref(labels).loginLink,
                  class: "c-button"
                }, _toDisplayString(_unref(labels).loginLink), 9, _hoisted_5))
          ]))
        : _createCommentVNode("", true),
      (_unref(createProfileLink))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(RouterLinkConditional, {
              class: "c-magic-line c-magic-line--underline",
              to: _unref(createProfileLink).url,
              "spa-enabled": _unref(createProfileLink).spaLink,
              title: _unref(labels).createAccountLink
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(labels).createAccountLink), 1)
              ]),
              _: 1
            }, 8, ["to", "spa-enabled", "title"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})